import type { Theme, ThemeColorKey } from '$lib/types/Theme';

export const getThemedOrCustomColor = (
    color: string | undefined,
    themeColorKey: ThemeColorKey,
    theme: Theme,
) => {
    if (!theme) {
        return color;
    }

    const themeColor = theme[themeColorKey];

    // if no color is defined or the defined color matches the themes color, return the theme color
    if (!color || color === themeColor || color === 'transparent') {
        return themeColor;
    }

    // else return custom color
    return color;
};
